module.exports = __webpack_public_path__ + "img/lock.fd7b41d.png";